export class RefCode {
  id: number;
  refDomainId: number;
  active: boolean;
  description: string;
  name: string;
  label?: string;         // combined name & description for dropdown
}
